import { render } from "./dcOwnerAsset.vue?vue&type=template&id=4cda6aea"
import script from "./dcOwnerAsset.vue?vue&type=script&lang=js"
export * from "./dcOwnerAsset.vue?vue&type=script&lang=js"

import "./dcOwnerAsset.vue?vue&type=style&index=0&id=4cda6aea&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/MODC/modc-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__